import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { TemperaturaRoteiro } from '../shared/interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class PopupTemperaturaRoteiroService {
  constructor(private apiConService: ApiConService) {}
  numeroRoteiro: number;
  loading = false;
  temperaturas: Array<TemperaturaRoteiro> = [];

  async buscaTemperaturaRoteiro(){
    try {
      this.temperaturas = [];
      this.loading = true;
      const response = await this.apiConService.patch('DCtemperaturaRoteiro/roteiro/' + this.numeroRoteiro);
      this.temperaturas = <TemperaturaRoteiro[]>response.response;
    } catch (error) {
      console.log(error);
    }finally{
      this.loading = false;
    }
  }
}
